import React from 'react';
import { useTranslation } from "react-i18next";

export default function OurTeam()
{
    const { t } = useTranslation();
    return(
        <section className="page-section bg-primary text-white mb-0" id="ourteam">
            <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-white">{t('nav_menu4')}</h2>
                <div className="row">
                    <img src="/assets/img/fabian_quiros.jpg" style={{marginTop:'20px'}} className="rounded-circle img-team img-responsive centerDiv" alt="Fabian Quirós Arce"/>
                    <h3 className="text-center">Fabian Quirós Arce</h3>
                    <p className="text-center">{t('team_text1')}</p>
                    <p className="text-center">{t('team_text2')}</p>
                </div>
                <div className="text-center mt-4">
                    <a style={{margin:'5px'}} className="btn btn-xl btn-outline-light" target='_blank' rel="noopener noreferrer" href="assets/CV_es.pdf">
                        <i className="fas fa-download me-2"></i>
                        {t('team_button1')}
                    </a>
                    <a style={{margin:'5px'}} className="btn btn-xl btn-outline-light" target='_blank' rel="noopener noreferrer" href="assets/CV_en.pdf">
                        <i className="fas fa-download me-2"></i>
                        {t('team_button2')}
                    </a>
                </div>
            </div>
        </section>
    )
}